import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Organization, Member, Business } from '../types';
import { firestoreApi } from './firestoreApi';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../Firebase/firebase';

export interface OrganizationState {
  organization: Organization;
}

const initialState: OrganizationState = {
  organization: {
    id: '',
    name: '',
    memberUids: [],
    createdAt: '',
    members: [],
    businesses: [],
    imageName: '',
  },
};

export const organizationApi = firestoreApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchOrganization: builder.query<Organization, string>({
      async queryFn(userId) {
        try {
          const organizationCollectionRef = collection(db, 'organization');
          const organizationCollectionQuery = query(
            organizationCollectionRef,
            where('memberUids', 'array-contains-any', [userId])
          );
          const organizationSnapshot = await getDocs(
            organizationCollectionQuery
          );
          const data = organizationSnapshot.docs.map((doc) => {
            return { ...(doc.data() as Organization), id: doc.id };
          });
          const memberCollectionRef = collection(
            db,
            `organization/${data[0].id}/members`
          );
          const memberSnapShot = await getDocs(memberCollectionRef);
          const memberData = memberSnapShot.docs.map((doc) => {
            return doc.data() as Member;
          });
          const businessCollectionRef = collection(
            db,
            `organization/${data[0].id}/businesses`
          );
          const businessSnapShot = await getDocs(businessCollectionRef);
          const businessData = businessSnapShot.docs.map((doc) => {
            return { ...(doc.data() as Business), id: doc.id };
          });
          const myOrganization: Organization = {
            id: data[0].id,
            name: data[0].name,
            createdAt: data[0].createdAt,
            memberUids: data[0].memberUids,
            members: memberData,
            businesses: businessData,
            imageName: data[0].imageName,
          };
          return { data: myOrganization };
        } catch (error: any) {
          console.error(error.message);
          return { error: error.message };
        }
      },
      providesTags: ['Organization'],
    }),
  }),
});

const organization = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganization: (state, action: PayloadAction<Organization>) => {
      state.organization = action.payload;
    },
  },
});

export const { setOrganization } = organization.actions;

export default organization.reducer;

export const { useFetchOrganizationQuery } = organizationApi;
